
import { RootState } from "@/@types/store";
import { computed, defineComponent, ref, watch } from "vue";
import { FormDialog, DefaultOptionSelect } from "@/components/Common";

import { useDialogCommon, useDialogFormData } from "@/hooks";
import { initFormData } from "./staffEditData";
import _ from "lodash";

import {
  AllGainRoles,
  DoUserPermissionInfo,
  GainUserRoleList,
  GetUserPermissionInfo,
  MerchantSheetQueryBySlaveAdmin,
} from "@/api-server/modules/defaultServer";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    formData: {
      type: Object,
      default: () => ({ ...initFormData }),
    },
  },

  components: {
    FormDialog,
    DefaultOptionSelect,
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const { visibleRef } = useDialogCommon(props, context);
    const { editFormData } = useDialogFormData(
      props,
      { ...initFormData },
      {
        type: "resetWithPropsFormData",
        visiableRef: visibleRef,
      },
      (editFormDataRef) => {
        console.log(editFormDataRef);
      }
    );
    const formDialogRefs = ref<any>(null);
    const partnerIdOptions = ref<any>([]);
    const roles = ref<any>([]);
    const roleList = ref<any>([]);
    const isIndeterminate = ref(true);
    const checkAll = ref(false);
    const partnerIds = ref<any>([]);
    let roleTypeList = ref<any>([]);
    const flag = ref(false);
    const store = useStore<RootState>();
    const roleType = computed(() => store.getters["user/roleType"]);
    const merchantInfoRoleIdList = computed(() => {
      return store.state.user.userInfo.menuRoleInfoCO.roleCOList.map((item) => {
        return item.roleId;
      });
    });

    const rules = {
      userName: [
        { required: true, message: "请输入员工姓名", trigger: "blur" },
      ],
      slavePhone: [
        { required: true, message: "请输入员工手机号", trigger: "blur" },
      ],
      roleIdList: [
        { required: true, message: "请选择角色", trigger: ["blur"] },
      ],
      partnerIdList: [
        {
          required: true,
          message: "请选择电子面单账号",
          trigger: ["blur"],
        },
      ],
    };
    const validateList = ref<any>([]);

    async function saveFormHandle() {
      roleTypeList.value = [];
      editFormData.value.roleIdList.map((item) => {
        roles.value.map((item1: any) => {
          if (item == item1.roleId) {
            roleTypeList.value.push(item1.roleName);
          }
        });
      });
      const params = {
        userName: props.type != 'batch' ? editFormData.value.staffName: undefined,
        slavePhone: props.type != 'batch' ? editFormData.value.staffPhone: undefined,
        slaveRelationUserList: props.type == 'batch' ? editFormData.value.slaveRelationUserList: undefined,
        roleIdList: editFormData.value.roleIdList,
        partnerIdList: editFormData.value.partnerIdList,
        roleType: roleTypeList.value,
        dataStatus: "1",
      };

      await DoUserPermissionInfo.fetch(params);
      ElMessage.success({ showClose: true, message: "编辑成功" });
      visibleRef.value = false;
      context.emit("updateSuccess");
    }
    async function getRoles() {
      const {
        data: { data },
      } = await AllGainRoles.fetch({
        roleType: String(roleType.value),
      });
      roles.value = data;
      roles.value.map((item:any)=>{
        if(item.roleId == 2){
          item.disabled = merchantInfoRoleIdList.value.includes(2)
        }
      })
    }
    async function getPartnerIds() {
      const {
        data: { data },
      } = await MerchantSheetQueryBySlaveAdmin.fetch({});
      partnerIdOptions.value = data;
      partnerIds.value = partnerIdOptions.value.map((item: any) => {
        return item.partnerId;
      });
    }

    const handleCheckAllChange = (val: any) => {
      editFormData.value.partnerIdList = val ? partnerIds.value : [];
      isIndeterminate.value = false;
    };
    const handleCheckedPartnerIdChange = (value: any) => {
      const checkedCount = value.length;
      checkAll.value = checkedCount === partnerIdOptions.value.length;
      isIndeterminate.value =
        checkedCount > 0 && checkedCount < partnerIdOptions.value.length;
    };
    async function getDefaultPartnerId() {
      const {
        data: { data },
      } = await GetUserPermissionInfo.fetch({
        userName: editFormData.value.staffName,
        slavePhone: editFormData.value.staffPhone,
      });
      // editFormData.value.partnerIdList =
      //   data.queryUserExist.partnerIdList || [];
      if (
        data.queryUserExist.partnerIdList &&
        data.queryUserExist.partnerIdList.length > 0
      ) {
        data.queryUserExist.partnerIdList.map((item: any) => {
          if (partnerIds.value.includes(item)) {
            editFormData.value.partnerIdList.push(item);
          }
        });
      }
    }
    async function getDefaultRoleId() {
      const {
        data: { data },
      } = await GainUserRoleList.fetch({
        userName: editFormData.value.staffName,
        slavePhone: editFormData.value.staffPhone,
      });
      editFormData.value.roleIdList = data || [];
    }

    watch(
      () => props.visible,
      async (n) => {
        if (!n) {
          return;
        }
        await getPartnerIds();
        await getRoles();
        props.type!='batch' && await getDefaultPartnerId();
        props.type!='batch' && await getDefaultRoleId();
      },
      { immediate: true }
    );

    return {
      store,
      formDialogRefs,
      rules,
      visibleRef,
      editFormData,
      saveFormHandle,
      validateList,
      partnerIdOptions,
      roles,
      getRoles,
      roleList,
      getPartnerIds,
      isIndeterminate,
      checkAll,
      handleCheckAllChange,
      handleCheckedPartnerIdChange,
      partnerIds,
      getDefaultPartnerId,
      roleTypeList,
      getDefaultRoleId,
      flag,
    };
  },
});
